import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Categories, CategoriesAddPayload, CategoriesEditPayload } from './categories.interface';
import { catchError, map, throwError } from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class CategoriesService {
    private token!: string;
    private basePath = environment.interop.basePath;

    private listUrl =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.categorii.list;

    public listDTUrl =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.categorii.listDT;

    private findURL =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.categorii.find;

    private storeURL =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.categorii.store;

    private updateUrl =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.categorii.update;

    private deleteUrl =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.categorii.delete;

    private listActiveUrl =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.categorii
            .listActive;

    private listPublicUrl =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.categorii
            .listPublic;

    private changeStatusActiveUrl =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.categorii
            .active;

    private changeStatusPublicUrl =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.categorii
            .public;

    private moveUpUrl =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.categorii
            .moveUp;

    private moveDownUrl =
        this.basePath +
        environment.interop.bulevart.nomenclatoare.categorii
            .moveDown;

    private httpOptions: any;

    constructor(private http: HttpClient) { }

    getListDT() {
        return this.http.get(this.listDTUrl, this.httpOptions);
    }

    findEntry(id: number) {
        return this.http.post(this.findURL + id, this.httpOptions);
    }

    storeEntry(payload: CategoriesAddPayload) {
        return this.http.post(this.storeURL, payload, this.httpOptions);
    }

    updateEntry(payload: CategoriesEditPayload) {
        return this.http.put(this.updateUrl, payload, this.httpOptions);
    }

    deleteEntry(id: number) {
        return this.http.delete(this.deleteUrl + id, this.httpOptions);
    }

    getListActive() {
        return this.http
            .get<{ errors: boolean; data: Categories[]; status_code: number }>(
                this.listActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.title,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get categories:', error);
                    return throwError(error);
                })
            );
    }

    getListPublic() {
        return this.http.get(this.listPublicUrl, this.httpOptions);
    }

    changeStatusActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }

    updatePosition(id: number, index: number) {
        if (index === 1) {
            // Position +1
            return this.http.put(this.moveUpUrl + id, {}, this.httpOptions);
        } else {
            // Position -1
            return this.http.put(this.moveDownUrl + id, {}, this.httpOptions);
        }
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
